import { Button } from "../ui/button";
import { Play } from "lucide-react";

interface WelcomeSectionProps {
  userName: string;
  onStartPractice?: () => void;
}

/**
 * Welcome section component for the dashboard
 * Displays personalized greeting and quick action button
 */
export function WelcomeSection({ userName, onStartPractice }: WelcomeSectionProps) {
  return (
    <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-primary to-primary/80 text-primary-foreground">
      <div className="absolute inset-0 bg-primary/20" />
      <img
        src="https://images.unsplash.com/photo-1517327017130-196393c792e7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzd2ltbWluZyUyMHBvb2wlMjBsYW5lcyUyMGNvbXBldGl0aW9ufGVufDF8fHx8MTc1ODg4NzIwMHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
        alt="Swimming pool"
        className="absolute inset-0 h-full w-full object-cover opacity-30"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
      <div className="relative p-8">
        <h1 className="text-3xl mb-2">Welcome back, {userName}</h1>
        <p className="text-primary-foreground/80 mb-4">
          Ready to make waves in your training?
        </p>
        <Button 
          className="bg-primary-foreground text-primary hover:bg-primary-foreground/90"
          onClick={onStartPractice}
        >
          <Play className="mr-2 h-4 w-4" />
          Start Today's Practice
        </Button>
      </div>
    </div>
  );
}

